
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { ChevronDown } from 'lucide-react';

interface MobileMenuProps {
  mobileMenuOpen: boolean;
  handleNavigation: (anchor?: string) => void;
  closeMobileMenu: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  mobileMenuOpen,
  handleNavigation,
  closeMobileMenu,
}) => {
  const location = useLocation();
  
  if (!mobileMenuOpen) return null;

  return (
    <div className="absolute top-full left-0 right-0 bg-white shadow-lg py-4 px-6 flex flex-col gap-4 animate-fade-in">
      <div className="py-2 border-b border-gray-100">
        <button className="w-full text-left py-2 flex justify-between items-center">
          <span className="text-brand-darkgrey font-medium">Offerings</span>
          <ChevronDown className="h-4 w-4 text-brand-grey" />
        </button>
        <div className="ml-4 my-2 flex flex-col gap-2">
          <Link 
            to="/subscription-model"
            className="text-brand-darkgrey py-1"
            onClick={() => handleNavigation()}
          >
            Hire yourself
          </Link>
          
          <Link 
            to="/assisted-sourcing-models"
            className="text-brand-darkgrey py-1"
            onClick={() => handleNavigation()}
          >
            Managed hiring (Assisted model)
          </Link>

          <a 
            href="https://cutshort.io/ai-screener" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-brand-darkgrey py-1"
            onClick={closeMobileMenu}
          >
            AI Screener
          </a>
        </div>
      </div>
      
      {location.pathname === '/' ? (
        <a 
          href="#plans" 
          className="text-brand-darkgrey py-2 border-b border-gray-100"
          onClick={closeMobileMenu}
        >
          Pricing
        </a>
      ) : (
        <Link 
          to="/#plans" 
          className="text-brand-darkgrey py-2 border-b border-gray-100"
          onClick={() => {
            closeMobileMenu();
            handleNavigation('#plans');
          }}
        >
          Pricing
        </Link>
      )}
      
      {/* <Link 
        to="/personas/cutshort-for-ta-leaders" 
        className={`py-2 border-b border-gray-100 relative ${location.pathname === '/personas/cutshort-for-ta-leaders' ? 'text-brand-blue font-medium' : 'text-brand-darkgrey'}`}
        onClick={closeMobileMenu}
      >
        <span className={location.pathname === '/personas/cutshort-for-ta-leaders' 
          ? 'text-brand-blue font-medium' 
          : 'bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-purple-500 font-medium'
        }>
          For TA Leaders
          <Badge 
            variant="outline" 
            className="absolute top-0 ml-2 text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
          >
            New
          </Badge>
        </span>
      </Link> */}
      
      <div className="py-2 border-b border-gray-100">
        <button className="w-full text-left py-2 flex justify-between items-center">
          <span className="text-brand-darkgrey font-medium">Resources</span>
          <ChevronDown className="h-4 w-4 text-brand-grey" />
        </button>
        <div className="ml-4 my-2 flex flex-col gap-2">
          <Link 
            to="/events" 
            className="text-brand-darkgrey py-1"
            onClick={closeMobileMenu}
          >
            Events
          </Link>
          <a 
            href="https://newsletter.cutshort.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-darkgrey py-1"
            onClick={closeMobileMenu}
          >
            Our newsletter
          </a>
          <Link 
            to="/reports" 
            className="text-brand-darkgrey py-1 flex items-center gap-2"
            onClick={closeMobileMenu}
          >
            Reports
            <Badge 
              variant="outline" 
              className="text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
            >
              New
            </Badge>
          </Link>
        </div>
      </div>
      
      <Link 
        to="/startup-offering"
        className={`py-2 border-b border-gray-100 relative ${location.pathname === '/startup-offering' ? 'text-brand-blue font-medium' : 'text-brand-darkgrey'}`}
        onClick={closeMobileMenu}
      >
        <span className={location.pathname === '/startup-offering' 
          ? 'text-brand-blue font-medium' 
          : 'text-brand-darkgrey'
        }>
          For early stage startups
          <Badge 
            variant="outline" 
            className="absolute top-0 ml-2 text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
          >
            New
          </Badge>
        </span>
      </Link>
      
      <a 
        href="https://cutshort.io/a/generic-emp-form" 
        target="_blank" 
        rel="noopener noreferrer"
        className="bg-brand-blue text-white py-2 px-4 rounded-lg text-center mt-2 shadow-sm"
        onClick={closeMobileMenu}
      >
        Get a callback
      </a>
    </div>
  );
};
